import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppUserState } from './shared/store/user/user.store';
import { Observable, take } from 'rxjs';
import { TAppUser } from './entity/types/tappuser';
import { setUser } from './shared/store/user/user.actions';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit, OnDestroy {
  title = 'regocheckapp';
  loggedInUser$: Observable<TAppUser>;

  constructor(private userStore: Store<AppUserState>,
    private ngZone: NgZone) {
    this.loggedInUser$ = this.userStore.select((state) => state.loggedInUser.user);
  }

  //listen for a postMessage()
  //this.app.onTokenRefresh.subscribe(newToken => window.postMessage(newToken));Copy Wrap 
  private handler = (event: MessageEvent) => {
    // ✅ Always validate origin
    //if (event.origin !== 'https://parent.example.com') return;

    if(event.data){
      console.log("from pro postMessage");
      console.log([event.data]);
      this.loggedInUser$.pipe(take(1))
      .subscribe((u)=> {
        
        if(u.userId){
          // const user: TAppUser = {
          //   userId: u.userId, 
          //   clientId:u.clientId, 
          //   token:event.data.newToken,
          //   role:u.role
          // };
          // this.userStore.dispatch(setUser({ user }));

          console.log("performing token refresh");

        }
        else{
          console.log("failed to get user for token refresh");
        }      
      });      
    }
    else{
      console.log("no payload for refresh");
    }

    // Re-enter Angular zone for change detection
    // this.ngZone.run(() => {
    //   console.log('Message from parent:', event.data);
    //   // ...update component state or emit to a service/store
    // });
  };

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      window.addEventListener('message', this.handler);
    }
  }

  ngOnDestroy(): void {
    if (typeof window !== 'undefined') {
      window.removeEventListener('message', this.handler);
    }
  }

}
